<template>
  <div>
    <div class="row mt-5">
      <div class="col">
        <div class="learn-title">
          <h5 class="sub-title-page">Investing Strategies</h5>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-12 col-12">
            <div class="p-3">
              <ul class="learn-list">
                <li>
                  The Ups and Downs of the Market
                </li>
                <li>SRO Report</li>
                <li>FOO Report</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-12">
            <div class="p-3">
              <ul class="learn-list">
                <li>
                  Stock Dividend Report
                </li>
                <li>Property Dividend Reportt</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-12">
            <div class="p-3">
              <ul class="learn-list">
                <li>
                  Invest in the Market NOW!!!
                </li>
                <li>How to Trade the Kangaroo Market</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>